<template>
  <div class="series-box">
    <div class="series-box-content">
      <div class="series-box-content-title">
        <div class="series-box-content-title-bar"></div>
        {{ title }}
      </div>
      <div class="series-box-content-info">
        <div class="series-box-content-info-box">
          <icon type="video-play-pc"></icon>
          <span class="series-box-content-info-text"> {{totalPostHits}} </span>
        </div>

        <div class="series-box-content-info-line" />

        <div class="series-box-content-info-content">
          <icon type="time-grey"></icon>
          <span class="series-box-content-info-text"> {{totalPostTime}} </span>
        </div>

        <div class="series-box-content-info-line" />

        <div class="series-box-content-info-box">
          <icon type="books-grey"></icon>
          <span class="series-box-content-info-text"> 共{{courseNum}}节 </span>
        </div>
      </div>
      <div class="series-box-content-handler">
        <cancel-learning
          :isJoinUserLearning="isJoinUserLearning"
          :isAllowUserLearningPush.sync="isAllowUserLearningPush"
          :isAllowUserLearningGlobalPush="isAllowUserLearningGlobalPush"
          :handleJoinUserLearningSuccess="handleJoinUserLearningSuccess"
          :handleCancelUserLearningSuccess="handleCancelUserLearningSuccess"
          :handleChangeIsAllowPush="handleChangeIsAllowPush"
          :handleChangeIsAllowGlobalPush="handleChangeIsAllowGlobalPush"
          :sid="sid"
          :currentId="currentId"
        />
      </div>
    </div>
    <div class="series-box-list" ref="scrollBox">
      <div v-for="(item, index) in data" :key="item.category">
        <div class="series-box-list-title ellipsis">
          {{ index + 1 }}. {{ item.info.title }}
        </div>
        <lr-link
          class="series-box-list-item"
          :to="`/learning/course/detail/id/${child.id}?sid=${sid}`"
          v-for="(child, cIndex) in item.list"
          :key="child.id"
          :class="{ active: +currentId === child.id }"
          :ref="+currentId === child.id ? 'activeItem' : undefined"
          @click="$emit('content-click', child)"
        >
          <div class="series-box-list-item-title-box">
            <div v-if="+currentId !== child.id" class="series-box-list-item-title-box-index">{{ index + 1 }}-{{ cIndex + 1 }}.</div>
            <div
              v-else
              class="series-box-list-item-title-box-index"
            >
              <icon type="playing"></icon>
            </div>
            <div class="series-box-list-item-title-box-title">{{ child.post_title }}</div>
            <div v-if="seriesProgressShow" class="series-box-list-item-title-box-progress">
              <div v-if="readPostIdMap[child.id] === '已学完'">
                <span>
                  <icon type="yes"></icon>
                </span>
                <span>已学完</span>
              </div>
              <div
                v-if="
                  readPostIdMap[child.id] &&
                  readPostIdMap[child.id] !== '已学完'
                "
              >
                <span> 播放至{{ readPostIdMap[child.id] }}% </span>
              </div>
              <div v-if="!readPostIdMap[child.id]">
                <span> 未学习 </span>
              </div>
            </div>
          </div>
          <div class="series-box-list-item-info">
            <span class="series-box-list-item-info-time">
              <icon type="video-play-pc"></icon>
              {{getCrowd(child.post_hits)}}
            </span>
            <div class="series-box-content-info-line" />
            <span class="series-box-list-item-info-volume">
              <icon type="time-grey"></icon>
              {{gethhmmss(child.time)}}
            </span>
            
          </div>
        </lr-link>
      </div>
    </div>
  </div>
</template>

<script>
import CancelLearning from './cancel-learning.vue';
import {
  gethhmmss,
  getCrowd
} from '@/common/utils';

export default {
  components: {
    CancelLearning,
  },
  props: {
    title: String,
    course: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    readPostIdMap: {
      type: Object,
      default: () => {},
    },
    sid: [Number, String],
    currentId: [Number, String],
    isSubscribe: [Boolean, Number],
    reportClick: Function,
    reportShow: Function,
    isJoinUserLearning: Boolean,
    isAllowUserLearningPush: Boolean,
    isAllowUserLearningGlobalPush: Boolean,
    handleJoinUserLearningSuccess: Function,
    handleCancelUserLearningSuccess: Function,
    handleChangeIsAllowPush: Function,
    handleChangeIsAllowGlobalPush: Function,
    seriesProgressShow: Boolean
  },

  watch: {
    data: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.scrollToActive());
      },
    },
  },

  methods: {
    /**
     * 滚动到当前系列课
     */
    scrollToActive() {
      const scrollBox = this.$refs.scrollBox;
      const activeItem = this.$refs.activeItem && this.$refs.activeItem[0].$el;

      if (activeItem && scrollBox) {
        scrollBox.scrollTo && scrollBox.scrollTo(0, activeItem.offsetTop - 100);
      }
    },
    getTotal() {
      this.data.forEach(subject=>{
        subject?.list?.forEach((course) => {
          this.courseNum ++;
          this.totalPostTime += course.time;
          this.totalPostHits += course.post_hits;
        });
      });
      this.totalPostTime = gethhmmss(this.totalPostTime);
      this.totalPostHits = getCrowd(this.totalPostHits);
    },
    gethhmmss,
    getCrowd
  },
  data() {
    return {
      courseNum: 0,
      totalPostTime: 0,
      totalPostHits: 0,
    };
  },

  mounted() {
    this.getTotal();
    this.reportShow({ show: 'subscribe' });
  },
};
</script>

<style lang="scss" scoped>
.series-box {
  width: 278px;
  background: #ffffff;
  border: 1px solid #e8e8e8;

  &-content {
    &-title {
      margin-top: 12px;
      padding: 0 14px;
      font-size: 16px;
      font-weight: 600;
      color: #222226;
      line-height: 22px;
      position: relative;
      &-bar {
        left: 0px;
        width: 4px;
        height: 18px;
        background: #545454;
        position: absolute;
      }
    }
    &-info {
      margin-top: 4px;
      padding: 0 14px;
      display: flex;
      color: #888888;
      font-size: 12px;

      &-line {
        align-self: center;
        width: 1px;
        height: 10px;
        border-left: 1px solid #d7d9de;
        margin: 0px 10px;
      }
    }
    &-handler {
      margin-top: 10px; 
      padding: 0 14px;
    }
  }

  &-list {
    margin-top: 20px;
    position: relative;
    height: 380px;
    overflow-y: auto;

    &-title {
      height: 34px;
      line-height: 34px;
      background: #f6f6f6;
      padding: 0 16px;
      font-size: 12px;
      font-weight: 600;
      color: #222226;
    }
  }
  &-list-item {
    display: block;
    padding: 10px 12px 10px 12px;
    cursor: pointer;

    &.active,
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    &-title-box {
      display: flex;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 4px;
      color: #222226;
      font-size: 12px;
      line-height: 17px;
      position: relative;
      &-title {
        max-width: 146px;
      }
      &-index {
        width: 30px;
      }
      &-progress {
        position: absolute;
        color: #6D7582;
        right: 0px;
      }
    }
    &-info {
      display: flex;
      font-size: 12px;
      color: #888888;
      margin-left: 30px;
      &-time {
        min-width: 50px;
      }
    }
  }

}
</style>